
import Vue from 'vue'
import Vuex from 'vuex'
import createPersist from 'vuex-localstorage'
import * as actions from './actions'
import * as getters from './getters'
import hub from './modules/hub'
import user from './modules/user'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

let localStorage = createPersist({
  namespace: 'SMOLIN_BUDGETPLAN_WEBSITE',
  initialState: {},
  expires: 1.21e+9 // Two Weeks
})

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    hub,
    user
  },
  strict: debug,
  plugins: []
})



// WEBPACK FOOTER //
// ./src/store/index.js